/**
 * Score de progression du profil (0-100%).
 *
 * Représente la "complétion" du quiz : 100% pile quand evaluateQuizState
 * dit `done = true` (volume + couverture des blocs importants atteints).
 *
 * Sinon : min entre la progression du volume et celle de la couverture
 * (le critère le plus en retard détermine la barre).
 *
 * Avantage : le user voit clairement quand il a fini (score 100%) et
 * comprend ce qui lui manque (le critère limitant).
 */

import { evaluateQuizState } from './quizCompletion.js';

const VOLUME_TARGET = 10;
const COVERAGE_TARGET = 0.35;

export function computeProfileScore(profile, blocks, dishes = []) {
  const state = evaluateQuizState(profile, dishes, blocks);

  if (state.done) {
    return {
      score: 100,
      label: 'Profil complet',
      color: 'emerald',
      votesCount: state.votesCount,
      touchedCategoriesCount: state.importantBlocksCovered
    };
  }

  const volumeRatio = Math.min(1, state.votesCount / VOLUME_TARGET);
  const coverageRatio = Math.min(1, state.blockCoverage / COVERAGE_TARGET);
  // Le critère limitant détermine la barre (un user à 50 votes mais 20% couverture
  // doit savoir qu'il manque encore de la diversité, pas du volume).
  const finalScore = Math.round(Math.min(volumeRatio, coverageRatio) * 99);

  let label, color;
  if (finalScore < 25) { label = 'Goûts à découvrir'; color = 'gray'; }
  else if (finalScore < 50) { label = 'Goûts en construction'; color = 'amber'; }
  else if (finalScore < 75) { label = 'Goûts bien définis'; color = 'orange'; }
  else { label = 'Profil presque complet'; color = 'emerald'; }

  return {
    score: finalScore,
    label,
    color,
    votesCount: state.votesCount,
    touchedCategoriesCount: state.importantBlocksCovered
  };
}
